export var InspectionReportKey;
(function (InspectionReportKey) {
    InspectionReportKey["EB_THERMOSTATS"] = "eb_thermostats";
    InspectionReportKey["VENSTAR_THERMOSTATS"] = "thermostats";
    InspectionReportKey["SITE_CONTROLLERS"] = "site_controllers";
    InspectionReportKey["SUPER_EDGE_CONTROLLERS"] = "super_edge_controllers";
    InspectionReportKey["EDGE_CONTROLLERS"] = "edge_controllers";
    InspectionReportKey["SUPER_HUBS"] = "super_hubs";
    InspectionReportKey["HUBS"] = "hubs";
    InspectionReportKey["SENSORS"] = "sensors";
    InspectionReportKey["SUPERHUB_SENSORS"] = "superhub_sensors";
    InspectionReportKey["SITE_TOTAL"] = "site_total";
    InspectionReportKey["ENERGY_PROS"] = "energy_pros";
    InspectionReportKey["ENERGY_PRO2S"] = "energy_pro2s";
})(InspectionReportKey || (InspectionReportKey = {}));
export var DAThermostatTileKey;
(function (DAThermostatTileKey) {
    DAThermostatTileKey["HVAC_TYPE"] = "HVAC_type";
})(DAThermostatTileKey || (DAThermostatTileKey = {}));
export var InspectionComponentName;
(function (InspectionComponentName) {
    InspectionComponentName["EDGE_CONTROLLER"] = "EdgeController";
    InspectionComponentName["SUPER_EDGE_CONTROLLER"] = "SuperEdgeController";
    InspectionComponentName["SITE_CONTROLLER"] = "SiteController";
    InspectionComponentName["SITE_CONTROLLER_ILO"] = "SiteController-ILO";
    InspectionComponentName["SITE_TOTAL"] = "Site Total";
    InspectionComponentName["ENERGY_PRO"] = "EnergyPro";
    InspectionComponentName["ENERGY_PRO2"] = "EnergyPro II";
    InspectionComponentName["HUB"] = "Energybox Hub";
    InspectionComponentName["EB_SUPER_HUB"] = "SuperHub";
    InspectionComponentName["THERMOSTAT"] = "Wifi Thermostat";
    InspectionComponentName["EB_THERMOSTAT"] = "Wireless Thermostat";
    InspectionComponentName["SENSORS"] = "Sensors";
    InspectionComponentName["UNPAIRED_SENSORS"] = "Unpaired Sensors";
    InspectionComponentName["EXTERNAL_SENSORS"] = "External Sensors";
    InspectionComponentName["EXTERNAL_WIRELESS_SENSORS"] = "External Sensors (Wireless only)";
    InspectionComponentName["SENSORS_NEARBY"] = "Sensors Nearby";
    InspectionComponentName["ACTUATORS"] = "Actuators";
    InspectionComponentName["RELAYS"] = "Relays";
})(InspectionComponentName || (InspectionComponentName = {}));
export var InspectionComponentToName;
(function (InspectionComponentToName) {
    InspectionComponentToName["edge_controllers"] = "EdgeController";
    InspectionComponentToName["super_edge_controllers"] = "SuperEdgeController";
    InspectionComponentToName["site_controllers"] = "SiteController";
    InspectionComponentToName["site_total"] = "Site Total";
    InspectionComponentToName["energy_pros"] = "EnergyPro";
    InspectionComponentToName["energy_pro2s"] = "EnergyPro II";
    InspectionComponentToName["hubs"] = "Energybox Hub";
    InspectionComponentToName["super_hubs"] = "SuperHub";
    InspectionComponentToName["thermostats"] = "Wifi Thermostat";
    InspectionComponentToName["eb_thermostats"] = "Wireless Thermostat";
    InspectionComponentToName["sensors"] = "Sensors";
})(InspectionComponentToName || (InspectionComponentToName = {}));
export var InspectionDetailLevel;
(function (InspectionDetailLevel) {
    InspectionDetailLevel["ISSUES"] = "Show Issues Only";
    InspectionDetailLevel["ALL"] = "Show All Details";
})(InspectionDetailLevel || (InspectionDetailLevel = {}));
export var InspectionStatus;
(function (InspectionStatus) {
    InspectionStatus["GOOD"] = "Good";
    InspectionStatus["WARNING"] = "Warning";
    InspectionStatus["ERROR"] = "Error";
})(InspectionStatus || (InspectionStatus = {}));
export var InspectionOnlineStatus;
(function (InspectionOnlineStatus) {
    InspectionOnlineStatus["online"] = "Online";
    InspectionOnlineStatus["offline"] = "Offline";
    InspectionOnlineStatus["ACTIVE"] = "Active";
    InspectionOnlineStatus["INACTIVE"] = "Inactive";
})(InspectionOnlineStatus || (InspectionOnlineStatus = {}));
